import $ from 'jquery';

export function modal($target) {
    const $bio = $target.closest('.educator-person');
    const $modal = $('#educator-bio-modal');
    const $body = $modal.find('ul');

    $target.on('click', () => {
        $body.html($bio.clone());
        $modal.modal('show');
    });
}
